<template>
  <v-layout class="pb-4" wrap>
    <v-flex>
      <statistics-filter
        @filter="send"
        search-label="Телефон"
        :filters="filters"
        :default-params="param"
        :loading="loading"
        :switched="'dark'"
      ></statistics-filter>
      <statistics-filter
        @filter="send"
        search-label="Телефон"
        :filters="filtersCopy"
        :default-params="paramCopy"
        :loading="loading"
        :switched="'light'"
      ></statistics-filter>
    </v-flex>
  </v-layout>
</template>

<script>
import StatisticsFilter from "./StatisticsFilter.vue";
export default {
  name: "StatisticsFilterComparision",

  components: { StatisticsFilter },

  props: {
    // активные фильтры
    filters: {
      type: Array,
      default: function() {
        return ["hotspot", "range"];
      }
    },

    // параметры фильтров по умолчанию
    defaultParams: Object,

    // статус загрузки
    loading: {
      type: Boolean,
      default: false
    }
  },

  data: () => ({
    // параметры формы первого фильтра
    param: null,
    // параметры формы второго фильтра, включая активные фильтры и значения по умолчанию
    paramCopy: null,
    filtersCopy: null
  }),

  beforeMount() {
    // устанавливаем параметры первого фильтра по умолчанию
    this.param = this.defaultParams.switcher
      ? this.defaultParams.params[0]
      : this.defaultParams;
    // создаем копии параметров для второго фильтра
    this.filtersCopy = [...this.filters];
    this.paramCopy = this.defaultParams.switcher
      ? this.defaultParams.params[1]
      : { ...this.defaultParams };
  },

  watch: {
    // обновление данных, если меняется шаблон
    defaultParams() {
      if (this.defaultParams.switcher) {
        this.param = this.defaultParams.params[0];
        this.paramCopy = this.defaultParams.params[1];
      }
    }
  },

  methods: {
    /**
     * Формирование массива хотспотов и отправка выбранного периода
     */
    send() {
      let hotspotsArrayToFilter = [];
      this.param.hotspotName = this.$store.getters.getHotspot(
        this.param.hotspot_id
      )["hotspot_name"];
      this.paramCopy.hotspotName = this.$store.getters.getHotspot(
        this.paramCopy.hotspot_id
      )["hotspot_name"];
      hotspotsArrayToFilter[0] = {
        ...this.param,
        range: {
          startDate: this.param.range.startDate,
          endDate: this.param.range.endDate
        }
      };
      hotspotsArrayToFilter[1] = {
        ...this.paramCopy,
        range: {
          startDate: this.paramCopy.range.startDate,
          endDate: this.paramCopy.range.endDate
        }
      };
      this.$emit("filter", hotspotsArrayToFilter);
    }
  }
};
</script>
